import { render, staticRenderFns } from "./DraftInvoice.vue?vue&type=template&id=3f033036&scoped=true&"
import script from "./DraftInvoice.vue?vue&type=script&lang=js&"
export * from "./DraftInvoice.vue?vue&type=script&lang=js&"
import style0 from "./DraftInvoice.vue?vue&type=style&index=0&id=3f033036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f033036",
  null
  
)

export default component.exports